<template>
    <div class="esignH5" ref="esignH5Div">
        <div class="signName-box">
            <esign 
                ref="signName" 
                :showCreateBtn="true" 
                :width="clientWidth"
                :height="clientHeight"
                @esignHandle="esignHandle"
            ></esign>
        </div>
    </div>
</template>
  
  <script>
  import esign from '@/components/esign';
  import { faceServe } from "@/api/home";
  import {putObject, uploadFiles, putObjectBlob} from "@/utils/upload";
  import {getStore} from "@/utils/localStorage";
  
  export default {
    name: "esignH5",
    components: { esign },
    data() {
      return {
        clientWidth: document.documentElement.clientWidth,
        clientHeight: document.documentElement.clientHeight - 60,
        tag: '',
        ENTRANCETYPE: '',
        isShow: false,
        drawer: false,
        direction: "btt",
        imgData: [],
        loading: false,
      };
    },
    created(){
    },
    mounted() {
      if(this.$route.query._ENTRANCETYPE){
        this.ENTRANCETYPE = this.$route.query._ENTRANCETYPE;
        this.$store.dispatch('permission/SETENTRANCETYPE', this.$route.query._ENTRANCETYPE);
      }
      if(this.$route.query.tag){
        this.tag = this.$route.query.tag;
      }
      // if(this.clientWidth < this.clientHeight){
      //   this.clientWidth = document.documentElement.clientHeight;
      //   this.clientHeight = document.documentElement.clientWidth - 60;
      //   this.$refs['esignH5Div'].style.transform = 'rotate(90deg)'; //使该元素转动90度，并使其斜屏展示}
      // }
      // const width = document.documentElement.clientWidth;
      // const height = document.documentElement.clientHeight;
      // const contentDOM = this.$refs['esignH5Div'];
      // if (width < height) {
      //   //如果 就是斜屏，屏幕的宽度就等同于屏高
      //   contentDOM.style.width = height + 'px';
      //   contentDOM.style.height = width + 'px';
      //   this.clientWidth = height;
      //   this.clientHeight = width;
      //   contentDOM.style.top = (height - width) / 2 + 'px';
      //   contentDOM.style.left = 0 - (height - width) / 2 + 'px';
      //   contentDOM.style.transform = 'rotate(90deg)';
      // } 
      // //根据手机旋转的角度来判断
      // const evt = "onorientationchange" in window ? "orientationchange" : "resize"; 
      // //转动事件
      // window.addEventListener(evt, function () { 
      //   //事件监听
      //   if (window.orientation === 90 || window.orientation === -90) { 
      //     //旋转到 90 或 -90 度，即竖屏到横屏
      //     //横屏，灵感的宽度就等同于屏高
      //     contentDOM.style.width = height + 'px';
      //     contentDOM.style.height = width + 'px';
      //     this.clientWidth = height;
      //     this.clientHeight = width;
      //     contentDOM.style.top = '0px';
      //     contentDOM.style.left = '0px';
      //     contentDOM.style.transform = 'none'; //不转动；
      //   }else{ 
      //     //旋转至 180 或 0 度，即横屏到竖屏
      //     //竖屏，灵感的宽度就等于屏高
      //     contentDOM.style.width = height + 'px';
      //     contentDOM.style.height = width + 'px';
      //     this.clientWidth = height;
      //     this.clientHeight = width;
      //     contentDOM.style.top = (height - width) / 2 + 'px';
      //     contentDOM.style.left = 0 - (height - width) / 2 + 'px';
      //     contentDOM.style.transform = 'rotate(90deg)'; //转动90度
      //   }
      // }, false);
      // console.log(this.clientWidth);
      // console.log(this.clientHeight);
    },
    methods: {
        esignHandle(res){
            faceServe.postPhoto({
                tag: this.tag,
                url: res
            }, this.tokenData).then(item => {
    
                if(item.data.code === 200) {
                    this.$message.success('签名成功');
                    return
                }
                this.$message.error("图片上传失败");
            });
        },
    },
  };
  </script>
  
  <style lang="scss" scoped>
    .esignH5{
        width: 100%;
        height: 100%;
        position: fixed;
        left: 0;
        top: 0;
        z-index: 999;
        background-color: #fff;
        // display: flex;
        // flex-direction: column;
        // align-items: center;
        overflow: hidden;
        .signName-box{
            // margin-top: 20px;
        }
    }
  </style>
  